import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {Divider} from '../../../../../../../commons/components/divider'
import {ticketsHaveSeats} from '../../../../../../../commons/selectors/tickets'
import {useAppSelector} from '../../../../hooks/runtime'
import {getFormattedOrderCreatedDate} from '../../../../selectors/dates'
import {getSuccessfulOrder} from '../../../../selectors/placed-order'
import c from '../../../classnames.scss'
import {BackToSiteLink} from '../../../common/back-to-site-link'
import {Invoice} from './invoice'
import s from './mobile.scss'

export const Mobile = () => {
  const {t} = useTranslation()

  const order = useAppSelector(getSuccessfulOrder)
  const formattedOrderCreatedDate = useAppSelector(getFormattedOrderCreatedDate)

  return (
    <div className={classNames(c.formLabelsColor, c.textFont)}>
      <div className={s.header}>
        <div className={s.orderNumber}>{t('ticketsThankYou.orderNo', {orderNumber: order.orderNumber})}</div>
      </div>
      <Divider />
      <div className={s.placedOn}>{t('ticketsThankYou.placedOn', {date: formattedOrderCreatedDate})}</div>
      <Divider />
      <Invoice orderHasSeats={ticketsHaveSeats(order?.tickets)} order={order} />
      <Divider />
      <BackToSiteLink className={s.link} />
    </div>
  )
}
